import { SystemState } from '../system/SystemState';

export const selectedAlertDetails = (state: SystemState) =>
  state.passiveParameters.selectedAlertDetails;

export const dailyMetricIsLoading = (state: SystemState) =>
  state.passiveParameters.isLoading;
